import { Telefone } from './telefone';
export class Referencia {
  public nome: string;
  public idGrauRelacionamento: number;
  public telefone: any;
  public relacaoClienteOutro: string;

  constructor(nome?: string, idGrauRelacionamento?: number, telefone?: Telefone, relacaoClienteOutro?: string) {
    this.nome = nome;
    this.idGrauRelacionamento = idGrauRelacionamento;
    this.telefone = telefone;
    this.relacaoClienteOutro = relacaoClienteOutro;
  }

  setNome(nome: string) {
    this.nome = nome;
  }

  setIdGrauRelacionamento(idGrauRelacionamento: number) {
    this.idGrauRelacionamento = idGrauRelacionamento;
  }

  setTelefone(telefone: Telefone) {
    this.telefone = telefone;
  }

  setRelacaoClienteOutro(relacaoClienteOutro: string) {
    this.relacaoClienteOutro = relacaoClienteOutro;
  }
}
